'use strict';

var deepGetProperty = require('../../common/internal/deepGetProperty'),
    createFormatMatcher = require('../../common/internal/createFormatMatcher');

module.exports = createFormatMatcher(deepGetProperty);


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/stringFormatMatcher.js
// module id = 986
// module chunks = 0